export default {
    required: [{
        required: true,
        message: '请输入必填字段',
        trigger: 'blur'
    }],
    changeIred: [{
        required: true,
        message: '请输入必填字段',
        trigger: 'change'
    }],
    no: [{
        required: false,
    }],
    num: (val) => {
        if (val) {
            var rule = new RegExp(`^\\d{${val}}$`)
            return [{
                    pattern: rule,
                    message: `请输入${val}位数字`
                },
                {
                    required: true,
                    message: `请输入必填字段`,
                    trigger: 'blur'

                },
                {
                    type: 'number',
                    message: '字段必须为数字值'
                }
            ]

        } else {
            return [{
                    required: true,
                    message: '请输入必填字段',
                    trigger: 'blur'
                },
                {
                    type: 'number',
                    message: '字段必须为数字值'
                }
            ]
        }
    },
    code: (val) => {
        return [{
            required: true,
            message: '请输入必填字段',
            trigger: 'blur'

        }, {
            pattern: new RegExp(`^[A-Za-z0-9]{${val}}$`),
            message: `输入英文或数字且为${val}位`
        }]
    }, //只能输入英文字母和数字且限制长度
    phone: [{
            required: true,
            message: '请输入必填字段',
            trigger: 'blur'
        },
        {
            pattern: /^1[3456789]\d{9}$/,
            message: `手机号码输入有误`
        }
    ],
    bigNum: [{
            required: true,
            message: '请输入必填字段',
            trigger: 'blur'
        },
        {
            pattern: /^[1-9]\d*$/,
            message: `输入大于0的正整数`
        }
    ],

    zeroNumed: [{
        required: true,
        message: '请输入必填字段',
        trigger: 'blur',
    }, {
        pattern: /^[0-9]\d*$/,
        message: `输入大于或等于0的正整数`
    }],
    money: [
        ///^d*(?:.d{0,2})?$/  
        {
            required: true,
            message: '请输入必填字段',
            trigger: 'blur'
        },
        {
            pattern: /^(([1-9]{1}\d*)|(0))(\.\d{1,2})?$/,
            message: `请输入正确的金额数字，最多两位小数`
        }
    ],
    notMoney: [
      ///^d*(?:.d{0,2})?$/  
      {
          required: true,
          message: '请输入必填字段',
          trigger: 'blur'
      },
      {
          pattern: /^(([1-9]{1}\d*))(\.\d{1,2})?$/,
          message: `请输入正确的金额数字，最多两位小数`
      }
    ],
    isMoney: [{
        pattern: /^(([1-9]{1}\d*)|(0))(\.\d{1,2})?$/,
        message: `请输入正确的金额数字，最多两位小数`
    }],
    isbigNum: [{
        pattern: /(^[1-9][0-9]+)?(\.[0-9]{1,2})?$/,
        message: `输入大于0的正整数`
    }],
    zeroNum: [{
        pattern: /^[0-9]\d*$/,
        message: `输入大于0的正整数`
    }],
    cardNum: [{
            required: true,
            message: '请输入必填字段',
            trigger: 'blur'
        },
        {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: `输入正确的身份证号码`
        }
    ],
	cardNumNoRequired: [
	    {
	        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
	        message: `输入正确的身份证号码`
	    }
	],
    ///(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    notChinese: [{
        required: true,
        message: '请输入必填字段',
        trigger: 'blur'

    }, {
        pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{0,}$/,
        message: `不能有除简体中文、英文、数字之外的其他文字或符号`
    }], //校验校验不能有除简体中文、英文、数字之外的其他文字或符号
    isEnglish: [{
        required: true,
        message: '请输入必填字段',
        trigger: 'blur'

    }, {
        pattern: /^[A-Za-z]+$/,
        message: `只能输入英文`
    }], //只能输入英文
    isChinese: [{
        required: true,
        message: '请输入必填字段',
        trigger: 'blur'
    }, {
        pattern: /^[\u4e00-\u9fa5]{3,}$/,
        message: `只输入中文校验，且长度大于3位`
    }], //限制只输入中文校验，且长度大于3位
}